export const isKeyboardEvent = (event) => {
  return event?.nativeEvent?.clientX === 0 && event?.nativeEvent?.clientY === 0;
};
